import React from "react";
import { Tooltip } from "@whatslly/ui-components/Tooltip";
import classnames from "classnames";
import styles from "./headerButton.module.scss";

interface HeaderButtonProps {
  onClick?: () => void;
  active?: boolean;
  tooltipText?: string;
  testId?: string;
  children?: React.ReactNode;
  className?: string;
}

export const HeaderButton: React.FC<HeaderButtonProps> = React.memo(({ children, active, onClick, testId, tooltipText, className }) => {
  return (
    <Tooltip disabled={!tooltipText} delay={300} placement="bottom" value={<span>{tooltipText}</span>}>
      <div
        data-testid={testId}
        className={classnames(styles.headerButtonContainer, className, {
          [styles.active]: active,
        })}
        onClick={onClick}
      >
        {children}
      </div>
    </Tooltip>
  );
});
